export default __webpack_public_path__ + "static/media/logoSingle.9f4fdab8.png";